import { Enums } from "utils";

export const sessionStorage = {
  /**
   * function to return the session object
   * @returns {any} either IUser or {}
   */

  get: (): any => {
    return window.sessionStorage.qubehub ? JSON.parse(window.sessionStorage.qubehub) : {};
  },

  /**
   * function to set the user session
   * @param {object} values the data to be stored
   */

  set: (values: object): void => {
    window.sessionStorage.qubehub = Object.keys(values).length === 0 ? "" : JSON.stringify({ ...sessionStorage.get(), ...values });
  },

  /**
   * function to clear the user session
   */

  clear: (): void => {
    window.sessionStorage.qubehub = "";
  },

  /**
   * function to return the access token
   * @returns {string} the access token or an empty string
   */

  accessToken: (): string => {
    return sessionStorage.get()?.wq ?? "";
  },

  /**
   * function to return if the userType is Clinic
   * @returns {boolean} true if the userType is Clinic, false otherwise
   */

  isClinic: (): boolean => {
    return sessionStorage.get()?.userType === Enums.EnumUser.Clinic;
  },

  /**
   * function to return if the userType is Provider
   * @returns {boolean} true if the userType is Provider, false otherwise
   */

  isProvider: (): boolean => {
    return sessionStorage.get()?.userType === Enums.EnumUser.Provider;
  },

  /**
   * function to return if the userType is Patient
   * @returns {boolean} true if the userType is Patient, false otherwise
   */

  isPatient: (): boolean => {
    return sessionStorage.get()?.userType === Enums.EnumUser.Patient;
  },
};
